export const WISH_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
};

const toDisplayDateTime = (value, fallback = "N/A") => {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleString();
};

export const formatDateTime = (value) => toDisplayDateTime(value, "");

/**
 * `wish` is already the normalized wish order (see services/normalizers.js),
 * so this only shapes it for the pricing screen's labels.
 */
export const mapWishToView = (wish) => {
  if (!wish) return null;

  return {
    id: wish._id || null,
    wishName: wish.dishName || "Untitled wish",
    wishDate: toDisplayDateTime(wish.desiredDate),
    timeSlot: wish.desiredTime || "",
    status: String(wish.status || WISH_STATUS.PENDING).toLowerCase(),
    wishImage: wish.photos?.[0] || "/Assets/Img/Recipe/imgHub_1_1.png",
    quantityText: `${wish.quantity || 0} ${wish.unit || "piece"}`,
    ingredientsText: wish.ingredients || "No suggested ingredients",
    additionalInfoText: wish.additionalInfo || "No additional info",
    agreedPrice: wish.agreedPrice ?? null,
    orderId: wish.orderId ?? null,
    sellerId: wish.sellerId?._id || null,
    sellerName: wish.sellerName || wish.sellerId?.name || "Seller",
    // The public wish DTO carries the kitchen's name but not its logo.
    sellerAvatar: "/Assets/Img/kitchen_default.png",
  };
};

/** Offers are already sorted oldest-first by the normalizer. */
export const mapNegotiationsToMessages = (negotiations = []) =>
  negotiations
    .filter((item) => item && typeof item === "object")
    .map((item, index) => ({
      id: item._id || String(index + 1),
      from: item.actor === "SELLER" ? "seller" : "customer",
      actor: item.actor,
      price: item.price,
      createdAt: item.createdAt,
    }));

export const getStatusClass = (status) => {
  if (status === WISH_STATUS.ACCEPTED) return "wop-status wop-status-accepted";
  if (status === WISH_STATUS.REJECTED || status === WISH_STATUS.CANCELLED)
    return "wop-status wop-status-rejected";
  if (status === WISH_STATUS.COMPLETED)
    return "wop-status wop-status-completed";
  return "wop-status wop-status-pending";
};

export const isPendingStatus = (status) => status === WISH_STATUS.PENDING;
